import * as React from 'react'
const DividerProcess = props => (
  <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.5 7L3.5 1V13L8.5 7Z" fill="#C4C6D2"/>
  </svg>
)

export default DividerProcess